import { Component } from '@verndale/core';
import Swiper from 'swiper';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $previews: this.el._$('.community-landing-masthead__previews'),
      $thumb: this.el._$$('.community-landing-masthead__thumb')
    };

    this.slider;
    this.activeThumbClass = 'community-landing-masthead__thumb--active';
    this.setActiveThumb(0);
    this.initSlider();
  }

  addListeners() {
    this.slider.on('activeIndexChange', this.handleSlideChange.bind(this));
    this.dom.$thumb.forEach((el, i) => el._on('click', this.handleThumbClick.bind(this, i)));
  }

  initSlider() {
    this.slider = new Swiper(this.dom.$previews, {
      autoHeight: true
    });
  }

  handleThumbClick(index) {
    this.slider.slideTo(index);
  }

  handleSlideChange() {
    this.setActiveThumb(this.slider.activeIndex);
  }

  setActiveThumb(index) {
    this.dom.$thumb.forEach(($thumb, i) => {
      const shouldAddClass = index === i;
      $thumb.classList.toggle(this.activeThumbClass, shouldAddClass);
    });
  }
}

export default Module;
